export default {
    parts: [
        'orderDetailHeading',
        'orderStatusText',
        'orderStatusInfoText',
        'orderNumberText',
        'orderNuberValue',
        'OrderDateText',
        'InStoreAddressLable',
        'InStoreAddress',
        'orderDateValue',
        'orderReturnStatusText',
        'brandNameText',
        'quantityPriceText',
        'quantityPriceShippingText',
        'saleOnText',
        'colorText',
        'sizeText',
        'lenghtText',
        'styleNumberText',
        'shippingAddressMainContainer',
        'shippingNameText',
        'shippingAddressHeading',
        'shippingMethodHeading',
        'shippingMethodText',
        'shippingMethodNumber',
        'shippingMethodbusinessDaysText',
        'shippingMethodStoreInfo',
        'paymentMethodContainer',
        'paymentMethodText',
        'paymentCardNameText',
        'paymentCardNumberText',
        'paymentCardDateText',
        'giftCardContainer',
        'giftCardAmount',
        'billingAddressHeading',
        'billingNameText',
        'billingStreetText',
        'billingPostalAddresText',
        'billingCountryText',
        'billingPhoneNoText',
        'brandNameShippingText',
        'orderSummmaryHeadingText',
        'orderSummarySubtotalText',
        'orderSummaryCurrencyText',
        'orderSummaryShippingText',
        'orderSummaryTaxesText',
        'orderSummaryTotalHeading',
        'orderSummaryTotalValueText',
        'productAttributesText'
    ],
    baseStyle: (props) => ({
        orderDetailHeading: {
            fontSize: {base: '20px', lg: '24px'},
            fontWeight: '700',
            lineHeight: {base: '24px', lg: '30px'},
            textTransform: 'uppercase'
        },
        orderStatusText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        orderStatusInfoText: {
            fontSize: {base: '11', lg: '12'},
            fontWeight: '500',
            textTransform: 'uppercase',
            lineHeight: {base: '18px', lg: '18px'}
        },
        orderNumberText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        orderNuberValue: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        OrderDateText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        InStoreAddressLable: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        InStoreAddress: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        orderDateValue: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        orderReturnStatusText: {
            fontSize: {base: '14', lg: '16'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        brandNameShippingText: {
            fontSize: {base: '12', lg: '12'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '18px'},
            textTransform: 'uppercase',
            color: '#676767'
        },
        shippingEmailText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        brandNameText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '500',
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'Capitalize'
        },
        quantityPriceText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: {base: '400', lg: '500'},
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'uppercase'
        },
        quantityPriceShippingText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: {base: '500', lg: '500'},
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'uppercase'
        },
        saleOnText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            textDecoration: 'line-through',
            color: 'gray.500'
        },
        colorText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        sizeText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        lenghtText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        styleNumberText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        shippingAddressMainContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItem: 'flexStart',
            padding: '16px',
            gap: '8px',
            border: '1px solid #ECE9E9'
        },
        shippingNameText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'Capitalize'
        },
        shippingAddressHeading: {
            fontSize: {base: '14px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodHeading: {
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodNumber: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        shippingMethodbusinessDaysText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            marginTop:"2px"
        },
        shippingMethodStoreInfo: {
            fontSize: { base: '12px', lg: '14px' },
            fontWeight: '400',
            lineHeight: { base: '18px', lg: '20px' },
            marginTop: "4px"
        },
        paymentMethodContainer: {
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid',
            borderColor: 'gray.200',
            gap: '16px',
            padding: '20px'
        },
        paymentMethodText: {
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        paymentCardNameText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        paymentCardNumberText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '18px', lg: '20px'}
        },
        paymentCardDateText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        giftCardContainer: {
            width: '100%',
            flexDirection: 'column',
            alignItems: 'start',
            padding: '16px',
            border: '1px solid',
            borderColor: 'gray.200'
        },
        giftCardAmount: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingAddressHeading: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        billingNameText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingStreetText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingPostalAddresText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingCountryText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingPhoneNoText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummmaryHeadingText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        orderSummarySubtotalText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryCurrencyText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryShippingText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryTaxesText: {
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryTotalHeading: {
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        orderSummaryTotalValueText: {
            fontSize: {base: '14px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        productAttributesText: {
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        }
    })
}